import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogLaravelArchitecture() {
  return <BlogDetailPage slug="laravel-application-architecture" />;
}